export const ValueSource = {
  CONSTANT: "CONSTANT",
  FIELD: "FIELD",
  SUM: "SUM",
  COUNT: "COUNT",
};

export const ValueSourceGlobalBusiness = {
  GLOBAL_BUSINESS: "GLOBAL_BUSINESS",
};

export const ValueSourceExt = {
  CONSTANT: "CONSTANT",
  FIELD: "FIELD",
  SUM: "SUM",
  COUNT: "COUNT",
  GLOBAL_BUSINESS: "GLOBAL_BUSINESS",
};

export const CUSTOM_QUERY_FIELD_ID = "{{__CUSTOM__}}";
export const ALL_VALUES_FILTER_PATH = "[*]";

export const ALL_VALUE_SOURCES = Object.values(ValueSource);

export const ValueSourceDisplayNameMap = {
  [ValueSource.FIELD]: "The field",
  [ValueSource.CONSTANT]: "The constant",
  [ValueSource.SUM]: "The sum of",
  [ValueSource.COUNT]: "The number of",
  [ValueSourceGlobalBusiness.GLOBAL_BUSINESS]: "The global business",
};

export const CheckComparator = {
  EQUALS: "=",
  NOT_EQUAL: "!=",
  LESS_THAN: "<",
  GREATER_THAN: ">",
  LESS_THAN_OR_EQUAL: "<=",
  GREATER_THAN_OR_EQUAL: ">=",
  CONTAINS: "contains",
  NOT_CONTAINS: "!contains",
};

export const CheckComparatorDisplayNameMap = {
  [CheckComparator.EQUALS]: "equals",
  [CheckComparator.NOT_EQUAL]: "doesn't equal",
  [CheckComparator.LESS_THAN]: "is less than",
  [CheckComparator.GREATER_THAN]: "is greater than",
  [CheckComparator.LESS_THAN_OR_EQUAL]: "is less than or equal to",
  [CheckComparator.GREATER_THAN_OR_EQUAL]: "is greater than or equal to",
  [CheckComparator.CONTAINS]: "contains",
  [CheckComparator.NOT_CONTAINS]: "doesn't contain",
};

export const FieldType = {
  NUMERIC: "NUMERIC",
  BUSINESS: "BUSINESS",
  BOOLEAN: "BOOLEAN",
};

export const FieldValueType = {
  BOOLEAN: "boolean",
  BUSINESS: "business",
  BUSINESS_NAME: "business_name",
  GST_APPLICABILITY_BOOLEAN: "gst_applicability_boolean",
  CURRENCY: "currency",
  INTEGER: "integer",
  WEIGHT: "weight",
};

export const FIELD_TYPE_MAP = {
  [FieldType.NUMERIC]: [
    FieldValueType.CURRENCY,
    FieldValueType.INTEGER,
    FieldValueType.WEIGHT,
  ],
  [FieldType.BUSINESS]: [FieldValueType.BUSINESS, FieldValueType.BUSINESS_NAME],
  [FieldType.BOOLEAN]: [
    FieldValueType.BOOLEAN,
    FieldValueType.GST_APPLICABILITY_BOOLEAN,
  ],
};

export const FeeOperator = {
  MULTIPLY: "*",
  DIVIDE: "/",
  ADD: "+",
  SUBTRACT: "-",
  ASSIGN: "=",
};

export const GST_FEE_NAME = "GST";
export const GST_FEE_EXCLUSIVE_MULTIPLIER = 0.1;
export const GST_FEE_INCLUSIVE_MULTIPLIER = 1 - 1 / 1.1;
export const GST_FEE_FIXED_FIELD = "gst_cents";

export const GstPricingType = {
  AUTO: "AUTO",
  EXCLUSIVE: "EXCLUSIVE",
  EXEMPT: "EXEMPT",
  INCLUSIVE: "INCLUSIVE",
  NOT_SET: "",
  FIELD_GST_CENTS: "FIELD_GST_CENTS",
};
